/**
 * The note under a Reviews heading while the section shows sample reviews,
 * which happens only before the business has a real one.
 * @returns {React.JSX.Element} The note.
 */
const SampleReviewsNote = (): React.JSX.Element => (
  <p className="jobsite:mt-4 jobsite:text-sm jobsite:font-body jobsite:text-muted-foreground">
    Sample reviews. This section appears on your site once you have a real review.
  </p>
);

export { SampleReviewsNote };
